import { gql } from 'apollo-boost';

export const allUsers = gql`
  query {
    allUsers {
      edges {
        node {
          dbId
          title
          phone
          enabled
          email
          firstName
          lastName
          userId
        }
      }
    }
  }
`;
